import { useTranslation } from 'react-i18next'
import Style from './index.module.less'
import classNames from 'classnames'
import { type Transition } from '@/hoxStore/interface'
import AddressHash from '../AddressHash'
import {
  getSendMsgTag,
  getTermsDay,
  getTransactionType,
  SendMsgTagArray,
} from '@/views/Transaction/utils'
import { formatTime } from '@/views/Home/utils'
import useMeNavigate from '@/hooks/useMeNavigate'
import { useEffect, useMemo, useRef, useState } from 'react'
import { Tooltip } from 'antd'
import { useGlobalStore } from '@/hoxStore/globalStore'
import { isEmptyOrNil } from '@/utils'
import { ValidatorNodeFormat } from '@/enums'
const LatestTransactions = ({ cardData = {} as Transition }: { cardData: Transition }) => {
  const navigate = useMeNavigate()
  const timeId = useRef<NodeJS.Timeout>()
  const { curReponsive } = useGlobalStore()
  const getType = (type: string) => {
    if (!type) return '-'
    const { pageTitle = '-' } = getTransactionType(type)! || {}
    return pageTitle
  }

  const { t } = useTranslation()
  const formatTimeAgo = (timeAgo: string) => {
    if (!timeAgo) return ''
    return timeAgo
      .replace('&_d', t('explorer_225'))
      .replace('&_h', t('explorer_224'))
      .replace('&_m', t('explorer_223'))
      .replace('&_s', t('explorer_21'))
  }
  const [time, setTime] = useState(formatTimeAgo(formatTime(cardData.block.timestamp) || ''))
  useEffect(() => {
    timeId.current = setInterval(() => {
      setTime(formatTimeAgo(formatTime(cardData.block.timestamp) || ''))
    }, 1000)
    return () => {
      clearTimeout(timeId.current)
    }
  }, [cardData.block.timestamp])

  const pageTitleFormat = useMemo(() => {
    const type = cardData?.msg_obj?.[0]?.type
    if (type === 'cosmos.bank.v1beta1.MsgSend') {
      const tag = cardData?.tag || ''
      if (SendMsgTagArray.includes(tag)) {
        return getSendMsgTag(tag, t)
      }
    }
    // AGE (CHN Node) 质押（存入） gea.staking.MsgCreateLockUpDelegate
    // AGE (CHN Node) 质押赎回 gea.staking.MsgReduceLockUpDelegation
    // AGD (CHN Node) 节点质押取回 gea.staking.MsgUnDelegate
    // AGD (CHN Node) 质押(存入) gea.staking.MsgCreateDelegate
    // AGS (CHN Node) 质押（{{ term }} 天） gea.staking.MsgCreateFixedDelegation
    // AGS (CHN Node) 质押赎回（30）天 gea.staking.MsgWithdrawFixedDelegation
    // AGE (CHN Node) 提取锁仓奖励 gea.staking.MsgWithdrawLockUpReward
    const pageTitle = getType(cardData?.msg_obj?.[0]?.type)
    let node = ''
    if (
      [
        'gea.staking.MsgReduceLockUpDelegation',
        'gea.staking.MsgCreateLockUpDelegate',
        'gea.staking.MsgUnDelegate',
        'gea.staking.MsgCreateDelegate',
        'gea.staking.MsgCreateFixedDelegation',
        'gea.staking.MsgWithdrawFixedDelegation',
        'gea.staking.MsgWithdrawLockUpReward',
      ].includes(type)
    ) {
      node = (cardData as any)?.msg_obj?.[0]?.extra_info?.region_id || '-'
      let term = (cardData as any)?.msg_obj?.[0]?.extra_info?.term || ''
      node = node.toLocaleUpperCase()
      if (node.endsWith('_VILLAGE')) {
        node = node.replace('_VILLAGE', '').toLocaleLowerCase()
        node = node.charAt(0).toUpperCase() + node.slice(1)
      }

      const replacedText = pageTitle.replace(
        /\{\{(.*?)\}\}/g, // 匹配 {{ ... }}
        (match: any, content: any) => {
          if (/regionId/.test(content)) {
            return node // {{ ... regionId ... }} → aa
          } else if (/term/.test(content)) {
            return getTermsDay(term) // {{ ... term ... }} → bb
          }
          return match // 其他情况保持不变
        },
      )
      if (node === '-' && replacedText.includes('Node')) {
        const newPageTitle = replacedText.replace(/(\s*Node\s*)/, '')
        return newPageTitle
      }
      return replacedText
    }
    return pageTitle
  }, [cardData])
  const getNode = (node: string) => {
    if (isEmptyOrNil(node)) return '-'
    const newNode = node.replace('-node', '').trim()
    if (ValidatorNodeFormat[newNode.toLocaleUpperCase() as keyof typeof ValidatorNodeFormat]) {
      return t(ValidatorNodeFormat[newNode.toLocaleUpperCase() as keyof typeof ValidatorNodeFormat])
    }
    return newNode.toLocaleUpperCase()
  }
  if (!cardData) return null
  return (
    <div className={'home_new_transition_item_wrap'}>
      <div className={'home_new_transition_item'}>
        <div className={Style.wrapItem}>
          <div
            className={classNames({
              [Style.title]: true,
              font_14: true,
              font_12: curReponsive?.size == 'mobile',
              [Style.first_title]: true,
            })}
          >
            <span style={{ marginRight: '4px' }}> {time}</span>
            {t('explorer_22')}
          </div>
          {/* <div
            className={classNames({
              [Style.timeNum]: true,
              font_14: true,
              [Style.lineHeight]: true,
            })}
          >
            {getNode(cardData?.block?.validator_description?.moniker)}
          </div> */}
        </div>
        <div className={Style.wrapItem}>
          <div
            className={classNames({
              [Style.title]: true,
              font_14: true,
              font_12: curReponsive?.size == 'mobile',
            })}
          >
            {t('explorer_53')}
          </div>
          <div
            className={classNames({
              /*失败状态*/
              [Style.transactionsStatus]: true,
              [Style.transactionsStatusFail]: !cardData?.success,
              font_14: true,
              font_12: curReponsive?.size == 'mobile',
            })}
          >
            {cardData.success ? t('explorer_25') : t('explorer_222')}
          </div>
        </div>
        <div className={Style.wrapItem}>
          <div
            className={classNames({
              [Style.title]: true,
              font_14: true,
              font_12: curReponsive?.size == 'mobile',
            })}
          >
            hash
          </div>
          <div
            className={classNames({
              [Style.hashText]: true,
              font_14: true,
              font_12: curReponsive?.size == 'mobile',
              [Style.lineHeight]: true,
            })}
          >
            <AddressHash
              data={cardData.hash}
              cutOption
              font_12={curReponsive?.size === 'mobile'}
              handleJump={() => {
                navigate(`/transaction/${cardData.hash}`)
              }}
            ></AddressHash>
          </div>
        </div>
        <div className={Style.wrapItem}>
          <div
            className={classNames({
              [Style.title]: true,
              font_14: true,
              font_12: curReponsive?.size == 'mobile',
            })}
          >
            {t('explorer_104')}
          </div>
          <div
            className={classNames({
              [Style.typeText]: true,
              font_14: true,
              font_12: curReponsive?.size == 'mobile',
              [Style.lineHeight]: true,
            })}
          >
            <Tooltip
              title={pageTitleFormat}
              placement={curReponsive?.size == 'mobile' ? 'top' : 'topLeft'}
            >
              <span className={Style.tooltipText}> {pageTitleFormat}</span>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LatestTransactions
